module.exports = __webpack_public_path__ + "/login_ui/img/mv-fa541791b8ae6b1869ba99642d50e89f.svg";